import React from 'react';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import './checkbox.scss';

const Checkbox = ({
    label,
    input,
    meta = {},
    highlightLabel = false,
    background,
    ...rest
}) => {
    const labelColor = highlightLabel && input && input.checked ? '#7740f9' : null;   

    return (
    <div
        className={classNames(
            'Checkbox',
            { 'has-error': meta.touched && meta.error },
        )}
        data-tip={meta.error}
    >
        <div className="round">
            <input
                type="checkbox"
                {...input}
                {...rest}
                style={{backgroundColor: background || '#fff', border:'1px solid #3F4244'}}
            />
            <label htmlFor={rest.id} />
        </div>
        <label className="input-label" htmlFor={rest.id} style={{ color: labelColor }}>
            {label}
        </label>
        {
            meta.touched
            && meta.error && (
                <ReactTooltip
                    type="error"
                    effect="solid"
                    place="top"
                />
            )
        }
    </div>
    );
};

export default Checkbox;
